module.exports = __webpack_public_path__ + "../assets/img/5fdf79d35d8a599940dfa074d8bd4a22.webp";